import React from "react";

const PageNotFound = () => {
  return (
    <div style={styles.container}>
      <div style={styles.frame}>
        <h1 style={styles.errorText}>404 Error</h1>
        <h2 style={styles.subText}>Page Not Found</h2>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    padding: "16px",
    textAlign: "center",
    backgroundColor: "var(--fk-bg)",
  },
  frame: {
    padding: "48px 56px",
    background: "var(--fk-surface)",
    border: "1px solid var(--fk-border)",
    borderRadius: "var(--fk-radius-lg)",
    boxShadow: "var(--fk-shadow), inset 0 0 0 10px var(--fk-beige)",
  },
  errorText: {
    fontFamily: "var(--fk-font-display)",
    fontSize: "2.75rem",
    fontWeight: 600,
    color: "var(--fk-brown-deep)",
    marginBottom: "8px",
  },
  subText: {
    fontSize: "1.1rem",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "var(--fk-text-muted)",
    margin: 0,
  },
};

export default PageNotFound;
